module.exports = __webpack_public_path__ + "img/e_1_11_g.4e56f12b.png";